export default __webpack_public_path__ + "static/media/transforming.92341e55.svg";